<template>
  <div class="c-result-top-infos__col--gray c-result-top-infos__col--radius result-user-info c-custom--h-100 mb-0">
    <v-row
      no-gutters
      class="align-center c-custom--h-100"
    >
      <v-col
        cols="12"
        sm=""
        class=""
      >
        <v-row class="font-weight-bold align-center result-user-info-result">
          <v-col
            cols="6"
            sm="6"
            md="6"
            class=""
          >
            <p class="c-result-title-size ma-0">現在の順位</p>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            class="text-right"
          >
            <span class="c-result-text-color--blue result-user-info-result__title">
              {{myRank}}
            </span>
            <span>位</span>
          </v-col>
        </v-row>
        <div class="result-user-info-resulttexts d-md-block d-sm-flex justify-center pt-3 pb-6 text-center">
          <p class="d-md-block text-center ma-0">現在の参加人数<span class="d-inline-block pl-2 font-weight-bold">{{participants}}人</span></p>
          <p class="d-md-block text-center ma-0">現在のポイント数<span class="d-inline-block pl-2 font-weight-bold">{{campaignUser.total_point}}P</span></p>
        </div>
        <div
          v-if="isTeam"
          class="result-user-info-btn"
        >
          <v-btn
            href="/team"
            rounded
            x-large
            elevation="0"
            class="c-result-btn--gray c-custom--w-100 font-weight-bold text-center"
          >
            チーム情報はこちら
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'

// ユーザーランクの取得
const getUserViewQuery = (campaignId) => `
  query getUserView {
    getUserView(campaign_id: "${campaignId}") {
      rank
    }
  }
`
const getUserViewInfo = async (campaignId) => {
  const { data: { getUserView: data } } = await GraphqlAPI(getUserViewQuery(campaignId))
  return data
}

export default {
  name: 'ResultTopicUserInfo',
  data () {
    return {
      participants: '',
      myRank: ''
    }
  },
  props: ['campaignUser', 'isTeam'],
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  async created () {
    this.getCampaignJson()
    // ユーザー取得（ランク）
    const userview = await getUserViewInfo(this.campaign.id)
    this.myRank = userview.rank ? userview.rank + '' : '未計算'
  },
  methods: {
    // cloudfront→S3からjsonファイルのキャンペーン参加者人数を取得 ※ログイン画面との整合性を合わせるため
    getCampaignJson () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/campaign_list.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            const campaignList = this.response
            const targetCampaign = campaignList.find(item => item.is_continuity === me.campaign.is_continuity)
            if (targetCampaign) {
              me.participants = targetCampaign.participants
            }
          }
        }
      }
    },
    openPDF (target) {
      window.open('/manual/' + target + '.pdf', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.result-user-info {
  .result-user-info-result {
    .result-user-info-result__title {
      font-size: 32px;
    }
  }
  .result-user-info-resulttexts {
    font-size: 15px;
  }
  .result-user-info-btn {
    width: min(77%, 230px);
    margin: 0 auto;
    @media screen and (min-width: 960px) {
      width: 100%;
    }
  }
}
.result_topic_tabel {
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem !important;
  th, td {
    padding: 5px 10px;
    border: 1px solid #ccc;
  }
  th {
    background-color: #FFF8E1;
  }
}
</style>
